export default function () {
  const csrfMeta = document.querySelector('meta[name=csrf-token]');

  return csrfMeta?.getAttribute('content') || false;
}
